import { PlanType } from '@labrav/react-components'
import { ContractDurationType } from '../../../types/flyout'
import type { CombinedFormState } from '../types'

export const processCombinedFormData = (
  data: CombinedFormState,
  productType: PlanType | undefined
) => {
  const { resellerAgreementData, cppoData } = data
  const {
    dimensions,
    currency,
    installmentInfo,
    awsProductId,
    contractDurationTimeUnit,
    contractDurationInMonthsForEndCustomer,
  } = resellerAgreementData
  const { offerExpirationDate } = cppoData
  const { adjustmentPercentage } = cppoData

  const updatedResellerDimensions = dimensions.map(dim => {
    return {
      ...dim,
      price: null,
      currency: currency,
    }
  })
  const updatedResellerInstallments = installmentInfo
    .filter(installment => installment.amount !== 0)
    .map(installment => ({
      ...installment,
      currency: currency,
    }))
  const updatedCppoInstallments = cppoData.installmentInfo
    .filter(installment => installment.amount !== 0)
    .map(installment => ({
      ...installment,
      currency: currency,
    }))
  let contractDurationInMonths = contractDurationInMonthsForEndCustomer
  if (
    contractDurationTimeUnit === 'YEARS' &&
    productType !== PlanType.SAAS_SUBSCRIPTION
  ) {
    contractDurationInMonths =
      (Number(contractDurationInMonthsForEndCustomer) || 0) * 12
  }

  const updatedDimensions = updatedResellerDimensions.map(dim => {
    if (dim.isAdditionalUsageAllowed && dim.prices?.additionalUsagePrice) {
      const increasedPrice =
        dim.prices.additionalUsagePrice *
        (1 + Number(adjustmentPercentage) / 100)

      return {
        ...dim,
        prices: {
          ...dim.prices,
          additionalUsagePrice: increasedPrice,
        },
        price: null,
      }
    } else if (dim.prices?.subscriptionPrice) {
      const increasedPrice =
        dim.prices.subscriptionPrice * (1 + Number(adjustmentPercentage) / 100)

      return {
        ...dim,
        prices: {
          ...dim.prices,
          subscriptionPrice: increasedPrice,
        },
        price: null,
      }
    } else {
      return dim
    }

    return dim
  })

  const updatedData = {
    ...data,
    resellerAgreementData: {
      ...resellerAgreementData,
      dimensions: updatedResellerDimensions,
      agreementExpirationDate: offerExpirationDate,
      contractDurationType:
        productType === PlanType.SAAS_SUBSCRIPTION
          ? ContractDurationType.STANDARD
          : ContractDurationType.CUSTOM,
      discountType:
        productType === PlanType.SAAS_SUBSCRIPTION
          ? 'individual_pricing'
          : 'flexible_payment_terms',

      installmentInfo: updatedResellerInstallments,
      contractDurationInMonthsForEndCustomer: contractDurationInMonths,
    },
    cppoData: {
      ...cppoData,
      dimensions: updatedDimensions,
      installmentInfo: updatedCppoInstallments,
      awsProductId: awsProductId,
      flexiblePaymentTerms:
        productType === PlanType.SAAS_SUBSCRIPTION ? false : true,
      serviceLength: contractDurationInMonths,
    },
  }
  return updatedData
}
